import { render, staticRenderFns } from "./TableHeaderToolTip.vue?vue&type=template&id=55f1288e&scoped=true&"
import script from "./TableHeaderToolTip.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderToolTip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f1288e",
  null
  
)

export default component.exports